(function(){

  /* =========================================================
   * 1. MOBILE MENU DELIVERY BANNER
   * ========================================================= */
  var DONE='data-lmf-banner';
  var BG='https://cdn.shopify.com/s/files/1/0835/4853/7051/files/Netanya_Beach_Promende_-_aerial_view.jpg?v=1782309751';
  function buildBanner(){
    var featured=document.querySelector('.menu-drawer__featured-content');
    if(!featured||featured.hasAttribute(DONE))return;
    featured.setAttribute(DONE,'1');
    featured.innerHTML='';
    var a=document.createElement('a');
    a.href='/collections/all';
    a.style.cssText=[
      'display:block','margin:12px 16px 20px','padding:28px 20px 24px',
      'border-radius:18px','color:#fff','text-align:center','text-decoration:none',
      'position:relative','overflow:hidden','box-shadow:0 8px 32px rgba(0,0,0,.28)',
      'background:url("'+BG+'") center/cover no-repeat'
    ].join(';');
    var overlay=document.createElement('div');
    overlay.style.cssText=[
      'position:absolute','inset:0',
      'background:linear-gradient(160deg,rgba(10,55,20,.72) 0%,rgba(20,80,35,.55) 100%)',
      'border-radius:18px'
    ].join(';');
    var inner=document.createElement('div');
    inner.style.cssText='position:relative;z-index:1;';
    inner.innerHTML=
      '<div style="font-size:36px;line-height:1;margin-bottom:10px;">\uD83D\uDE80</div>'+
      '<div style="font-size:20px;font-weight:900;letter-spacing:-.3px;margin-bottom:3px;text-shadow:0 2px 8px rgba(0,0,0,.4);">Livraison en 1 heure</div>'+
      '<div style="font-size:13px;opacity:.92;font-weight:500;margin-bottom:16px;text-shadow:0 1px 4px rgba(0,0,0,.4);">\u00e0 Netanya \u0026 alentours</div>'+
      '<span style="display:inline-block;padding:10px 26px;background:#fff;color:#1a5c2a;border-radius:50px;font-size:13px;font-weight:800;box-shadow:0 2px 12px rgba(0,0,0,.2);">Commander maintenant</span>';
    a.appendChild(overlay);
    a.appendChild(inner);
    featured.appendChild(a);
  }
  var mobileObs=new MutationObserver(buildBanner);
  mobileObs.observe(document.body,{childList:true,subtree:true});
  setTimeout(buildBanner,200);
  document.addEventListener('click',function(e){
    if(e.target.closest('summary,.header__icon--menu'))setTimeout(buildBanner,200);
  });

  /* =========================================================
   * 2. DESKTOP MEGA-MENU PRODUCT SHUFFLE
   * ========================================================= */
  var SHUFFLED='data-lmf-shuffled';
  function shuffleEl(parent){
    var kids=Array.from(parent.children);
    if(kids.length<2)return;
    for(var i=kids.length-1;i>0;i--){
      var j=Math.floor(Math.random()*(i+1));
      if(i!==j)parent.insertBefore(kids[j],kids[i]);
      var tmp=kids[i];kids[i]=kids[j];kids[j]=tmp;
    }
  }
  function shuffleDesktopProducts(){
    document.querySelectorAll('.mega-menu__content-list--products').forEach(function(list){
      if(list.hasAttribute(SHUFFLED))return;
      list.setAttribute(SHUFFLED,'1');
      shuffleEl(list);
    });
  }
  var desktopObs=new MutationObserver(function(muts){
    var needCheck=false;
    muts.forEach(function(m){
      if(m.type==='attributes'&&m.attributeName==='aria-expanded')needCheck=true;
      if(m.type==='childList')needCheck=true;
    });
    if(needCheck)shuffleDesktopProducts();
  });
  desktopObs.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-expanded']});
  setTimeout(shuffleDesktopProducts,300);

  /* =========================================================
   * 3. LANGUAGE FLAG SWITCHER
   * ========================================================= */
  var FLAG_DONE='data-lmf-flags';
  var LANG_FLAGS={
    'fr':'\uD83C\uDDEB\uD83C\uDDF7',
    'en':'\uD83C\uDDEC\uD83C\uDDE7',
    'he':'\uD83C\uDDEE\uD83C\uDDF1',
    'ru':'\uD83C\uDDF7\uD83C\uDDFA',
    'it':'\uD83C\uDDEE\uD83C\uDDF9'
  };

  function switchLanguage(langCode, form) {
    var f = document.createElement('form');
    f.method = 'post';
    f.action = '/localization';
    f.style.display = 'none';
    var fields = {
      '_method': 'PUT',
      'language_code': langCode,
      'return_to': window.location.pathname + window.location.search
    };
    var existingToken = form ? form.querySelector('[name="authenticity_token"]') : null;
    if (existingToken) {
      fields['authenticity_token'] = existingToken.value;
    } else {
      var anyToken = document.querySelector('[name="authenticity_token"]');
      if (anyToken) fields['authenticity_token'] = anyToken.value;
    }
    Object.keys(fields).forEach(function(k) {
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = k;
      inp.value = fields[k];
      f.appendChild(inp);
    });
    document.body.appendChild(f);
    f.submit();
  }

  function buildFlagSwitcher(){
    document.querySelectorAll('.localization-form__select[name="language_code"]').forEach(function(select){
      if(select.hasAttribute(FLAG_DONE)||select.options.length<2)return;
      select.setAttribute(FLAG_DONE,'1');
      var container=select.closest('.language-selector');
      if(!container)return;
      var form = select.closest('form');
      select.style.cssText='position:absolute;opacity:0;pointer-events:none;width:1px;height:1px;';
      var caret=container.querySelector('.svg-wrapper.icon-caret');
      if(caret)caret.style.display='none';
      var bar=document.createElement('div');
      bar.style.cssText='display:flex;gap:4px;align-items:center;flex-wrap:wrap;';
      Array.from(select.options).forEach(function(opt){
        var emoji=LANG_FLAGS[opt.value.toLowerCase()]||opt.value.toUpperCase();
        var isActive=(opt.value===select.value);
        var btn=document.createElement('button');
        btn.type='button';
        btn.setAttribute('title',opt.text);
        btn.setAttribute('aria-label',opt.text);
        btn.setAttribute('data-lang',opt.value);
        btn.style.cssText=[
          'font-size:22px','line-height:1','background:none',
          'border:2.5px solid '+(isActive?'currentcolor':'transparent'),
          'border-radius:50%','width:36px','height:36px',
          'cursor:pointer','display:flex','align-items:center',
          'justify-content:center','padding:0',
          'opacity:'+(isActive?'1':'0.55'),
          'transition:opacity .2s,border-color .2s',
          'flex-shrink:0'
        ].join(';');
        btn.textContent=emoji;
        btn.addEventListener('click',function(){
          if(select.value===opt.value)return;
          switchLanguage(opt.value, form);
        });
        bar.appendChild(btn);
      });
      container.appendChild(bar);
    });
  }

  setTimeout(buildFlagSwitcher,800);
  var flagObs=new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes.forEach(function(n){
        if(n.nodeType===1)setTimeout(buildFlagSwitcher,200);
      });
    });
  });
  flagObs.observe(document.body,{childList:true,subtree:true});

})();
